import { http } from '../http'
import { secureLocalStorageGet } from '../../helpers/index'
import userGWFragments from '@shared/hooks/usegwFragments'

export const getAllDetailsInfosOrder = async (
  orderNo: string
): Promise<any[]> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/details',
      data: {
        ...userFragments,
        orderNo,
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.message)
  }
  return data.data.data
}
